import { useState, useEffect } from 'react';

import { getRedeemedGiftCards, redeemGiftCard } from '../services/gifting';

const useRedeemCards = () => {
  const [giftCards, setGiftCards] = useState([]);

  const getCards = () => {
    getRedeemedGiftCards()
      .then((response) => {
        if (response && response.success) {
          setGiftCards(response.giftCards);
        }
      })
      .catch((error) => error);
  };

  const handleRedeemCard = (redemptionCode) =>
    new Promise((resolve, reject) => {
      redeemGiftCard(redemptionCode)
        .then((response) => {
          if (response.success) {
            getCards();
            resolve(response);
          }
          reject(response);
        })
        .catch((error) => reject(error));
    });

  useEffect(() => {
    getCards();
  }, []);

  return { giftCards, handleRedeemCard };
};

export default useRedeemCards;
